module.exports = __webpack_public_path__ + "static/media/abtus.8a2f13e2.svg";